import { useState } from "react";
import IconChevronRight from "../Icons/IconChevronRight"; //@ts-ignore
import { ANIMATION_DURATION } from "../Misc/Constants";
import FormOption from "./Helpers/FormOption";
import DropDownCard from "./Helpers/DropDownCard";
import FormElementWrapper from "./Helpers/FormElementWrapper";
import Input, { IFormComponent } from "./Input";

export default function Select(props: IFormComponent) {
  const [value, setValue] = useState<string | null>(null);
  const [label, setLabel] = useState<string | null>(null);
  const [open, setOpen] = useState(false);

  const handleValue = (value: string) => {
    setValue(value);
    props.onChange?.(value);
  };

  const handleLabel = (label: string) => {
    setLabel(label);
  };

  const handleOpen = () => {
    setOpen(!open);
  };

  return (
    <FormElementWrapper
      onClick={handleOpen}
      icon={props.icon}
      small={props.small}
    >
      {/* TEXT */}
      <div className="focus:border-none focus:outline-none overflow-hidden text-ellipsis font-semibold w-full">
        {value === null ? (
          <div
            className={`${
              props.small && "text-small font-medium"
            }text-brij-DarkGrey`}
          >
            {props.default ? props.default : props.placeholder}
          </div>
        ) : (
          <div
            className={`${
              props.small && "font-medium text-small"
            } text-brij-DarkGrey whitespace-nowrap overflow-hidden text-ellipsis`}
          >
            {label}
          </div>
        )}
      </div>
      {/* ICON */}
      <div
        className={`${props.small ? "h-5 w-5" : "h-6 w-6"} ${
          open &&
          `rotate-90 transition ease-out duration-[${ANIMATION_DURATION}ms]`
        }`}
      >
        <IconChevronRight />
      </div>
      {/* DROPDOWN */}
      {open && (
        <DropDownCard>
          <div>
            {props.onAddOption && (
              <button
                className={`text-left box-border p-3 text-brij-DarkGrey hover:text-brij-Blue hover:bg-gray-100 w-full ${
                  props.small && "text-xsmall font-medium"
                }`}
                onClick={() => {
                  props.onAddOption!();
                }}
              >
                Add New Option +
              </button>
            )}
          </div>
          {props.options &&
            props.options.map((option) => (
              <div className="flex flex-row" key={option.value}>
                <FormOption
                  small={props.small}
                  label={option.label}
                  value={option.value}
                  handleValue={handleValue}
                  handleLabel={handleLabel}
                />
                {props.onDelete && option.value && (
                  <button
                    onClick={() => {
                      props.onDelete!(option.value!);
                    }}
                  >
                    delete
                  </button>
                )}
              </div>
            ))}
        </DropDownCard>
      )}
    </FormElementWrapper>
  );
}
